
import Button from '../../../components/base/Button';

export default function ProductsSection() {
  const products = [
    {
      icon: 'ri-book-open-fill',
      title: 'Welcome Guidebook Template',
      description: 'Professional welcome guides that enhance guest experience and reduce support requests.',
      price: '$29',
      originalPrice: '$39',
      features: ['Customizable templates', 'Local area information', 'House rules & instructions', 'Emergency contacts'],
      popular: false,
      color: 'from-emerald-500 to-teal-500'
    },
    {
      icon: 'ri-checkbox-circle-fill',
      title: 'Cleaning & Turnover Checklist',
      description: 'Comprehensive checklists to ensure consistent quality between guest stays.',
      price: '$19',
      originalPrice: '$29',
      features: ['Room-by-room checklists', 'Quality control standards', 'Maintenance tracking', 'Staff training guides'],
      popular: false,
      color: 'from-blue-500 to-cyan-500'
    },
    {
      icon: 'ri-message-3-fill',
      title: 'Automated Guest Messaging Templates',
      description: 'Pre-written message templates for seamless guest communication throughout their stay.',
      price: '$39',
      originalPrice: '$49',
      features: ['Pre-arrival messages', 'Check-in instructions', 'During-stay follow-ups', 'Post-checkout reviews'],
      popular: true,
      color: 'from-teal-500 to-emerald-500'
    },
    {
      icon: 'ri-file-chart-fill',
      title: 'DSCR Loan Mini Guide',
      description: 'Essential guide to understanding and securing DSCR loans for investment properties.',
      price: '$49',
      originalPrice: '$59',
      features: ['Loan qualification criteria', 'Application process', 'Lender recommendations', 'Case studies'],
      popular: false,
      color: 'from-blue-600 to-green-500'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-blue-50 via-emerald-50 to-teal-50 relative overflow-hidden" data-product-shop>
      {/* Vibrant background elements */}
      <div className="absolute inset-0">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-gradient-to-r from-emerald-200/40 to-blue-200/40 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-gradient-to-r from-teal-200/40 to-cyan-200/40 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-gradient-to-r from-blue-200/30 to-green-200/30 rounded-full blur-2xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-20">
          <div className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-emerald-600 to-blue-600 text-white rounded-full text-sm font-semibold mb-8 shadow-lg">
            <i className="ri-shopping-bag-fill mr-2"></i>
            Digital Products
          </div>
          <h2 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-slate-900 to-slate-700 bg-clip-text text-transparent mb-6">
            Choose Your Toolkit
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed">
            Select from our collection of professional digital products designed to streamline your hosting operations.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16" data-product-shop>
          {products.map((product, index) => (
            <div key={index} className="group relative" data-product-shop>
              {/* Popular badge */}
              {product.popular && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 z-20">
                  <div className="bg-gradient-to-r from-teal-600 to-emerald-600 text-white px-4 py-2 rounded-full text-xs font-bold shadow-lg">
                    <i className="ri-star-fill mr-1"></i>
                    MOST POPULAR
                  </div>
                </div>
              )}
              
              <div className="bg-white/90 backdrop-blur-sm rounded-xl p-8 hover:shadow-xl transition-all duration-500 transform hover:-translate-y-2 border border-white/50 hover:border-white/80 flex flex-col h-full shadow-lg hover:bg-white/95">
                <div className="text-center mb-8">
                  <div className={`w-16 h-16 bg-gradient-to-r ${product.color} rounded-xl flex items-center justify-center mx-auto mb-6 shadow-lg group-hover:shadow-xl transition-all duration-300 transform group-hover:scale-110`}>
                    <i className={`${product.icon} text-2xl text-white`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-slate-900 mb-4 group-hover:text-slate-700 transition-colors duration-300">{product.title}</h3>
                  <div className="flex items-center justify-center gap-3 mb-4">
                    <span className="text-3xl font-bold text-slate-900">{product.price}</span>
                    <span className="text-lg text-slate-500 line-through">{product.originalPrice}</span>
                  </div>
                </div>
                
                <p className="text-slate-600 mb-8 leading-relaxed text-center">{product.description}</p>
                
                <ul className="space-y-3 mb-8 flex-grow">
                  {product.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center text-slate-700 text-sm">
                      <div className="w-5 h-5 flex items-center justify-center mr-3">
                        <i className="ri-check-line text-emerald-600 text-lg"></i>
                      </div>
                      {feature}
                    </li>
                  ))}
                </ul>
                
                <Button className={`w-full bg-gradient-to-r ${product.color} hover:shadow-lg transform hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer mt-auto border-0 font-semibold text-white`}>
                  <i className="ri-download-line mr-2"></i>
                  Get Now
                </Button>
              </div>
            </div>
          ))}
        </div>
        
        {/* Bundle section */}
        <div className="text-center">
          <div className="relative bg-white/90 backdrop-blur-sm rounded-2xl p-12 max-w-4xl mx-auto border border-white/50 shadow-xl overflow-hidden">
            {/* Vibrant background decoration */}
            <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-r from-emerald-200/40 to-blue-200/40 rounded-full blur-2xl"></div>
            <div className="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-r from-teal-200/40 to-cyan-200/40 rounded-full blur-2xl"></div>
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-40 h-40 bg-gradient-to-r from-blue-200/30 to-green-200/30 rounded-full blur-3xl"></div>
            
            <div className="relative z-10">
              <div className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-emerald-600 to-blue-600 text-white rounded-full text-sm font-bold mb-6 shadow-lg">
                <i className="ri-gift-fill mr-2"></i>
                SPECIAL BUNDLE OFFER
              </div>
              <h3 className="text-3xl font-bold text-slate-900 mb-6">Complete Host Toolkit Bundle</h3>
              <p className="text-slate-600 mb-8 text-lg">Get all four digital products at a special bundle price and save 25%</p>
              <div className="flex items-center justify-center gap-6 mb-8">
                <span className="text-2xl text-slate-500 line-through">$136</span>
                <span className="text-5xl font-bold text-slate-900">$99</span>
                <div className="bg-gradient-to-r from-emerald-600 to-blue-600 text-white px-4 py-2 rounded-full text-sm font-bold shadow-lg">
                  <i className="ri-price-tag-3-fill mr-1"></i>
                  Save $37
                </div>
              </div>
              <Button size="lg" className="bg-gradient-to-r from-emerald-600 to-blue-600 hover:from-emerald-500 hover:to-blue-500 text-white font-bold shadow-xl transform hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer">
                <i className="ri-shopping-cart-fill mr-2"></i>
                Get Complete Bundle
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}